import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

export function rowsToSheetData(rows, columns) {
  if (!rows?.length) return [{ Note: "No data" }];
  return rows.map((row) => {
    const out = {};
    columns.forEach((col) => {
      out[col.header] = row[col.key] ?? "";
    });
    return out;
  });
}

export function exportAttendanceReportExcel({
  rows,
  columns,
  sheetName = "Report",
  fileName = "attendance-report.xlsx",
  metaRows = [],
}) {
  const wb = XLSX.utils.book_new();
  const data = rowsToSheetData(rows, columns);
  const ws = XLSX.utils.json_to_sheet([]);
  if (metaRows.length) {
    XLSX.utils.sheet_add_aoa(ws, metaRows, { origin: "A1" });
    XLSX.utils.sheet_add_json(ws, data, { origin: `A${metaRows.length + 2}`, skipHeader: false });
  } else {
    XLSX.utils.sheet_add_json(ws, data, { origin: "A1" });
  }
  const colWidths = columns.map((col) => ({
    wch: Math.max(
      col.header.length,
      ...data.map((r) => String(r[col.header] ?? "").length)
    ) + 2,
  }));
  ws["!cols"] = colWidths;
  XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 31));
  XLSX.writeFile(wb, fileName);
}

export function exportAttendanceReportPdf({
  title,
  subtitle = "",
  rows,
  columns,
  fileName = "attendance-report.pdf",
  metaLines = [],
}) {
  const doc = new jsPDF({ orientation: columns.length > 7 ? "landscape" : "portrait" });
  let y = 14;
  doc.setFontSize(14);
  doc.text(title, 14, y);
  y += 6;
  if (subtitle) {
    doc.setFontSize(10);
    doc.text(subtitle, 14, y);
    y += 5;
  }
  metaLines.forEach((line) => {
    doc.setFontSize(9);
    doc.text(String(line), 14, y);
    y += 4;
  });
  autoTable(doc, {
    startY: y + 2,
    head: [columns.map((c) => c.header)],
    body: (rows || []).map((row) => columns.map((c) => String(row[c.key] ?? ""))),
    styles: { fontSize: 8, cellPadding: 2 },
    headStyles: { fillColor: [220, 38, 38], textColor: 255 },
    alternateRowStyles: { fillColor: [248, 250, 252] },
  });
  doc.save(fileName);
}
